<template>
  <b-modal
    id="decommissionModal"
    size="md"
    content-class="sub-menu-bg-blue-transparent dc-modal"
    title="Decommission Serial Number"
    hide-footer
    no-fade
    header-close-variant="light"
  >
    <div class="dc-body">

      <!-- Warning strip -->
      <div class="dc-warning-strip">
        <fa :icon="['fas', 'exclamation-triangle']" class="dc-warning-icon" />
        <span>This will permanently decommission the system.</span>
      </div>

      <!-- System info card -->
      <div class="dc-info-card">
        <div class="dc-info-row">
          <span class="dc-label">System</span>
          <span class="dc-value">{{ system }}</span>
        </div>
        <div class="dc-info-row">
          <span class="dc-label">Scanner</span>
          <span class="dc-value">{{ scanner }}</span>
        </div>
        <div class="dc-info-row">
          <span class="dc-label">Serial No.</span>
          <span class="dc-value">{{ serialNumber }}</span>
        </div>
      </div>

      <!-- Confirmation text -->
      <p class="dc-confirm-text">
        System <b class="dc-highlight">{{ system }}</b> with Scanner
        <b class="dc-highlight">{{ scanner }}</b> and Serial Number
        <b class="dc-highlight">{{ serialNumber }}</b> will be set to
        <b class="dc-highlight dc-highlight--danger">DECOMMISSIONED</b>.
      </p>

      <!-- Actions -->
      <div class="dc-actions">
        <b-button class="dc-confirm-btn" @click="submitDecommission()">
          Confirm Decommission
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_DPR_SerialNumberChange',
  props: ['incomingData'],
  data() {
    return {
      region: '',
      scanner: 0,
      serialNumber: '',
      system: ''
    }
  },
  methods: {
    submitDecommission() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/decommissionSystem', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              region: this.region,
              scanner: this.scanner,
              serialNumber: this.serialNumber,
              system: this.system
            }
          })
          .then(response => {
              const content = response.data

              let successCheck =
                  content.msg == 'success'
                  ? 'Decommission successful.'
                  : 'Failed to decommission system.'

              this.$bvToast.toast(successCheck, {
                  title: 'Decommission System',
                  toaster: 'b-toaster-top-right'
              })

              this.$emit('updateSystems', content.obj)
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    }
  },
  watch: {
    incomingData: function (newValue, oldValue) {
      this.region = this.incomingData.region
      this.scanner = this.incomingData.scanner
      this.serialNumber = this.incomingData.serialNumber
      this.system = this.incomingData.systemName
    }
  }
}
</script>

<style scoped>
.dc-body {
  padding: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Warning strip */
.dc-warning-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 13px;
  background: rgba(224, 90, 90, 0.1);
  border: 1px solid rgba(224, 90, 90, 0.3);
  border-left: 3px solid #e05a5a;
  border-radius: 6px;
  font-size: 13px;
  color: #c0392b;
}
.dc-warning-icon {
  color: #e05a5a;
  flex-shrink: 0;
}

/* System info card */
.dc-info-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background: rgba(6, 60, 109, 0.04);
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 6px;
}
.dc-info-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.dc-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.6);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  min-width: 72px;
}
.dc-value {
  font-size: 13.5px;
  color: #063c6d;
  font-weight: 500;
}

/* Confirmation text */
.dc-confirm-text {
  font-size: 13px;
  color: rgba(6, 60, 109, 0.7);
  line-height: 1.65;
  margin: 0;
}
.dc-highlight {
  color: #063c6d;
  font-weight: 600;
}
.dc-highlight--danger {
  color: #e05a5a;
}

/* Actions */
.dc-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}
.dc-confirm-btn {
  background: rgba(224, 90, 90, 0.18) !important;
  border: 1px solid rgba(224, 90, 90, 0.45) !important;
  color: #e05a5a !important;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 6px;
  transition: background 0.15s;
  box-shadow: none !important;
}
.dc-confirm-btn:hover {
  background: rgba(224, 90, 90, 0.3) !important;
}
</style>
